import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

// const [data, setData] = useState('')
const initialState = {
    isLogin: false,
    editorial: {},
    toastData: {},
};

const homeSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setEditorialById(state, action) {
            state.editorial = action.payload;
        },
        settoastData(state, action) {
            state.toastData = action.payload;
        },
    },
});

export const { settoastData, setEditorialById } = homeSlice.actions;

export const EditorialsgetById = (id) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_URL}/journal/editorialpaneDetails/${id}`).then((res) => {
        // dispatch(settoastData({ status: true, message: "You are Loged in !" }));
        dispatch(setEditorialById(res?.data));
        // localStorage.setItem("user", JSON.stringify(res.data))
    })
        .catch((err) => {
            dispatch(settoastData({ status: false, message: err?.response?.data }));
        })
    return response;
}
const editorialReducer = homeSlice.reducer;

export default editorialReducer;
